import {ResolveFn} from '@angular/router';
import {EILoginData} from './components/login-form/login-form.component';

export const LoginResolver: ResolveFn<EILoginData> = (): EILoginData => {
    const ei: EILoginData = {...(window as any).eaglei};

    /**
     * Spring sends the session variables back as 'true' or 'false'.
     * Dumb
     */

    if (typeof ei.disabled === 'string') {
        ei.disabled = ei.disabled === 'true';
    }
    if (typeof ei.locked === 'string') {
        ei.locked = ei.locked === 'true';
    }
    if (typeof ei.verify === 'string') {
        ei.verify = ei.verify === 'true';
    }

    /**
     * Listen to the reload event. If the user reloads the page then clear the errors
     * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
     */
    const nav = performance.getEntriesByType('navigation');
    let reset = false;

    nav.forEach((entry: PerformanceNavigationTiming) => {
        if (entry.type === 'reload') {
            reset = true;
        }
    });

    if (reset) {
        ei.disabled = null;
        ei.locked = null;
        ei.verify = null;
    }

    /**
     * Clear out the window variables so that they don't conflict with anything else
     */
    (window as any).eaglei.locked = null;
    (window as any).eaglei.disabled = null;
    (window as any).eaglei.verify = null;

    return ei;
};
